import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function AboutUs() {
  return (
    <>
      <Helmet>
        <title>About Us - TEJ Solutions Hub</title>
        <meta name="description" content="Learn about TEJ Solutions Hub - Full-service software development company founded by Zebedee McLaurin in Atlanta, GA." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 2rem', color: 'white', textAlign: 'center' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>About TEJ Solutions Hub</h1>
            <p style={{ fontSize: '1.25rem', opacity: '0.95' }}>
              Transforming businesses through innovative technology solutions
            </p>
          </div>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '4rem 2rem' }}>
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>Our Story</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              Founded by Zebedee McLaurin, TEJ Solutions Hub (TEJ SUSTAINABILITY GROUP, INC.) was established to bridge the gap between businesses and cutting-edge technology. Based in Atlanta, Georgia, we've been helping companies transform their digital presence since 2020.
            </p>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563' }}>
              Our mission is to provide comprehensive software development and digital marketing solutions that drive real business results. From web development to SMS campaigns, we handle every aspect of your digital transformation.
            </p>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>What We Do</h2>
            <div style={{ display: 'grid', gap: '1.5rem' }}>
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'start' }}>
                <span style={{ fontSize: '2rem' }}>💻</span>
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Software Development</h3>
                  <p style={{ color: '#6b7280', lineHeight: '1.8' }}>Custom web and mobile applications built with modern technologies and best practices.</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'start' }}>
                <span style={{ fontSize: '2rem' }}>🎯</span>
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Digital Marketing</h3>
                  <p style={{ color: '#6b7280', lineHeight: '1.8' }}>Comprehensive marketing strategies including SEO, social media, and content marketing.</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'start' }}>
                <span style={{ fontSize: '2rem' }}>☁️</span>
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Cloud Solutions</h3>
                  <p style={{ color: '#6b7280', lineHeight: '1.8' }}>Scalable cloud infrastructure on AWS, Azure, and GCP with DevOps expertise.</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'start' }}>
                <span style={{ fontSize: '2rem' }}>📱</span>
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>SMS/Email Campaigns</h3>
                  <p style={{ color: '#6b7280', lineHeight: '1.8' }}>A2P 10DLC compliant messaging campaigns for client engagement and retention.</p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>Our Values</h2>
            <ul style={{ fontSize: '1.1rem', color: '#4b5563', lineHeight: '2', paddingLeft: '1.5rem' }}>
              <li><strong>Innovation:</strong> Staying ahead with the latest technologies</li>
              <li><strong>Quality:</strong> Delivering excellence in every project</li>
              <li><strong>Integrity:</strong> Honest, transparent communication</li>
              <li><strong>Compliance:</strong> Following all regulations and best practices</li>
              <li><strong>Customer Success:</strong> Your growth is our priority</li>
            </ul>
          </div>

          <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '3rem', borderRadius: '16px', color: 'white', textAlign: 'center' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '1rem' }}>Company Information</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginTop: '2rem' }}>
              <div>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem' }}>Legal Entity</div>
                <div style={{ fontSize: '0.95rem', opacity: '0.9' }}>TEJ SUSTAINABILITY GROUP, INC.</div>
              </div>
              <div>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem' }}>EIN</div>
                <div style={{ fontSize: '0.95rem', opacity: '0.9' }}>86-3326707</div>
              </div>
              <div>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem' }}>Founded</div>
                <div style={{ fontSize: '0.95rem', opacity: '0.9' }}>2020</div>
              </div>
              <div>
                <div style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem' }}>Location</div>
                <div style={{ fontSize: '0.95rem', opacity: '0.9' }}>Atlanta, GA</div>
              </div>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/contact" style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
              color: 'white',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 8px 24px rgba(124, 58, 237, 0.3)',
              marginRight: '1rem'
            }}>
              Work With Us
            </Link>
            <Link to="/services" style={{
              display: 'inline-block',
              background: 'white',
              color: '#7c3aed',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              border: '2px solid #7c3aed'
            }}>
              Our Services
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
